var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__title" }, [
        _c("h5", [_vm._v("Imprimir")]),
        _vm._v(" "),
        _c("div", { staticClass: "card__controls" }, [
          _c(
            "button",
            {
              staticClass: "btn-success",
              attrs: { type: "button" },
              on: { click: _vm.imprimir }
            },
            [
              _c("i", { staticClass: "fa fa-print" }),
              _vm._v(" "),
              _c("span", [_vm._v("Imprimir")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c("div", { staticClass: "form-field" }, [
              _c("p", [
                _c("label", { attrs: { for: "a4" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.tipoImpresion,
                        expression: "tipoImpresion"
                      }
                    ],
                    attrs: { type: "radio", id: "a4", value: "a4" },
                    domProps: { checked: _vm._q(_vm.tipoImpresion, "a4") },
                    on: {
                      change: function($event) {
                        _vm.tipoImpresion = "a4"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Formato A4")])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-field" }, [
              _c("p", [
                _c("label", { attrs: { for: "puntoVenta" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.tipoImpresion,
                        expression: "tipoImpresion"
                      }
                    ],
                    attrs: { type: "radio", id: "puntoVenta", value: "PV" },
                    domProps: { checked: _vm._q(_vm.tipoImpresion, "PV") },
                    on: {
                      change: function($event) {
                        _vm.tipoImpresion = "PV"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Formato punto de venta")])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec3a0688", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec3a0688","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Imprimir.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-ec3a0688","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Imprimir.vue
// module chunks = 0